import { AppInputNumber } from 'shared/UI/UIKit/InputNumber';
import { educationParallelTextRepresentation } from 'entities/education-class';
import type { ColumnsType } from 'antd/es/table';
import type { MaxLessonsPerDayConfigurationItem } from 'shared/api';

export const getColumns = (
  readOnly?: boolean,
  onValueChange?: (index: number, value: number | null) => void,
): ColumnsType<MaxLessonsPerDayConfigurationItem> => [
  {
    key: 'parallel',
    title: 'Параллель',
    dataIndex: ['parallel'],
    render: (parallel: MaxLessonsPerDayConfigurationItem['parallel']) =>
      educationParallelTextRepresentation[parallel],
  },
  {
    key: 'maxLessonsPerDay',
    title: 'Максимум уроков в день',
    dataIndex: ['maxLessonsPerDay'],
    render: (value, _record, index) => {
      if (readOnly) return value;

      return (
        <AppInputNumber
          min={1}
          max={8}
          precision={0}
          value={value ?? null}
          onChange={(nextValue) => onValueChange?.(index, nextValue)}
        />
      );
    },
  },
];
